import { useParams, Link } from "react-router";
import AppNavigation from "./AppNavigation";
import policies from "../../shared/legalPolicies.json";
import privacy from "../policies/privacy.json";
import terms from "../policies/terms.json";
import "./PolicyPage.css";

export default function PolicyPage() {
  const { policy } = useParams();
  const document = policies.policies.find(item => item.slug === policy);
  const publishedHtml = { privacy, terms }[policy]?.html;
  return <div className="min-h-screen bg-white text-gray-950"><AppNavigation />
    <main className="mx-auto max-w-3xl px-4 py-10 sm:px-8">
      {!document ? <><h1 className="text-2xl font-semibold">Policy not found</h1><Link to="/policies/terms" className="mt-4 inline-block underline">Terms and Conditions</Link></> : publishedHtml ? <article aria-label={document.title} className="termly-policy" dangerouslySetInnerHTML={{ __html: publishedHtml }} /> : <>
        <p className="text-sm font-semibold text-orange-700">Qronus / Draft / Not yet effective</p>
        <h1 className="mt-3 text-2xl font-semibold sm:text-3xl">{document.title}</h1>
        <p className="mt-3 break-words text-sm text-gray-600">Version {policies.version}</p>
        <aside className="my-6 border-l-2 border-orange-700 pl-4 text-sm leading-6">
          These policies are under review. Contact address and effective date are pending. Verified parental consent, refund eligibility and processing workflows, retention schedules and owner payout terms are not finalised. Draft acknowledgement is not consent to future final terms or verified parental consent.
        </aside>
        <dl className="space-y-2 border-y border-gray-100 py-5 text-sm">
          <div><dt className="font-semibold">Operator</dt><dd>{policies.operator}, operating as Qronus</dd></div>
          <div><dt className="font-semibold">Public support and privacy contact</dt><dd><a className="break-all underline" href={`mailto:${policies.supportEmail}`}>{policies.supportEmail}</a></dd></div>
          <div><dt className="font-semibold">Contact address</dt><dd>Pending before publication</dd></div>
          <div><dt className="font-semibold">Effective date</dt><dd>Not yet effective</dd></div>
        </dl>
        {document.sections.map(([heading, text]) => <section key={heading} className="mt-8"><h2 className="text-lg font-semibold">{heading}</h2><p className="mt-2 whitespace-pre-wrap text-sm leading-7 text-gray-700">{text}</p></section>)}
      </>}
    </main>
  </div>;
}
